import OrderUpsellTileWithTracking from 'components/Common/OrderUpsellTileWithTracking'
import LineHotAirBalloonIcon from 'LuxKit/Icons/line/LineHotAirBalloonIcon'
import React from 'react'
import { useIntl } from 'react-intl'

interface Props {
  tourUpsellData: App.TourUpsell
  variant?: 'compact' | 'default'
  onDismiss?: () => void
}

function TourOptionUpsellTile(props: Props) {
  const {
    tourUpsellData,
    variant = 'default',
    onDismiss,
  } = props
  const intl = useIntl()

  const {
    onClick,
    price,
  } = tourUpsellData

  return <OrderUpsellTileWithTracking
    title={intl.formatMessage({
      id: 'UysluWReoL',
      defaultMessage: 'More things to do on your tour',
      description: 'Title for tour option upsell tile on booking confirmation',
    })}
    description={intl.formatMessage({
      id: 'fyu4suCTSC',
      defaultMessage: 'Personalise your tour with optional experiences.',
      description: 'Description for tour option upsell tile on booking confirmation',
    })}
    price={price}
    priceUnit="person"
    currencyFormat="dynamicDollar"
    IconComponent={LineHotAirBalloonIcon}
    onClick={onClick}
    analyticsSubject="tour"
    variant={variant}
    onDismissClick={onDismiss}
  />
}

export default TourOptionUpsellTile
